const locale = {
  "signin.title": "Iniciar Sessión",
  "signin.label.dont.have.account": "No tienes una cuenta?",
  "signin.link.forgot.password": "Olvidaste la contraseña?",
  "signin.button.submit": "Iniciar",
  "signin.label.welcome.first": "Bienvenido a",
  "signin.label.welcome.second": "nuestra compañia",
  "signin.label.welcome.third": "Inventaria ayuda a desarrolladores y reclutadores a encontrarse y asi poder administrar mejor sus proyectos. Unete y comienza a buscar empleados o puestos hoy.",

  "toopbar.menu.profile": "Mi Perfil",
  "toopbar.menu.signout": "Cerrar sessión",

  "sidebar.link.users": "Usuarios",
  "sidebar.menu.admin.title": "Paneles",
  "sidebar.menu.admin.subtitle": "Panel de admin",
  "sidebar.menu.automation.subtitle": "Panel de automaciones",

  "users.title": "Usuarios",
  "users.label.users": "usuario/s",
  "users.placeholder.search": "Buscar usuarios",
  "users.label.no.users": "No hay usuarios!",
  "users.label.projects": "proyecto/s",
  "users.modal.create.title": "Crear Usuario",

  "user.link.users": "Usuarios",
  "user.label.details": "Detalles de usuario",
  "user.tab.info": "Información",
  "user.tab.courses": "Cursos",
  "user.label.no.exist": "Usuario no existe",
  "user.label.search": "Buscar usuario",
  "user.modal.courses.title": "Cursos",
  "user.course.subscription": "Fecha de suscripción: {{date}}",

  "user.role.admin": "Administrador",
  "user.role.professor": "Profesor",
  "user.role.student": "Estudiante",
  "user.role.automation": "Automatización",

  "alert.sure.title": "Está seguro?",
  "alert.sure.delete.company": "Eliminar la compañia {{company}}",
  "alert.sure.delete.user": "Eliminar al usuario {{user}} de la compañia",
  "alert.sure.cancel.button": "Cancelar",
  "alert.sure.confirm.button": "Sí, eliminar",

  "select.placeholder" : "Seleccionar",
  "select.option.all" : "Todos",
  "select.option.active" : "Activos",
  "select.option.inactive" : "Inactivos",

  "label.name": "Nombre",
  "label.description": "Description",
  "label.email": "Email",
  "label.password": "Contraseña",
  "label.role": "Rol",
  "label.phone": "Teléfono",
  "label.country": "País",
  "label.city": "Ciudad",
  "label.status": "Estado",
  "label.color": "Color",
  "label.professor": "Profesor",
  "label.category": "Caterogía",
  "label.accessible": "Siempre accesible",
  "label.categories": "Categorías",

  "button.select" : "Seleccionar",
  "button.create": "Crear",
  "button.add": "Agregar",
  "button.add.module": "Agregar Módulo",
  "button.add.class": "Agregar Clase",
  "button.update" : "Editar",
  "button.delete" : "Eliminiar",
  "button.save" : "Guardar",
  "button.assign" : "Asignar",
  "button.assigned" : "Asignado",
  "button.block" : "Bloquear",
  "button.unblock" : "Desbloquear",
  "button.categories": "Categorías",
}

export default locale;
